import React from "react";

import { ReactComponent as StopIcon } from "../../icons/stop.svg";
import { Button } from "src/app/components/Button/Button";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";

interface ActionButtonProps {
  isUploading: boolean;
  disabled: boolean;
  canSend: boolean;
  isArchived: boolean;
  onSend: () => void;
  onAbort: () => void;
}

export default function ActionButton({
  isUploading,
  disabled,
  canSend,
  isArchived,
  onSend,
  onAbort,
}: ActionButtonProps) {
  if (isUploading) {
    return (
      <button className="chat-input__btn" disabled type="button">
        <span className="chat-input__spinner" />
      </button>
    );
  }

  if (isArchived) {
    return (
      <Button
        variant="blue"
        onClick={onSend}
        disabled
        type="button"
        size="medium"
        className="chat-input__send-btn"
      >
        <IDHFormattedMessage id="ws_send" defaultMessage="Send" />
      </Button>
    );
  }

  if (disabled) {
    return (
      <button className="chat-input__btn" onClick={onAbort} type="button">
        <StopIcon />
      </button>
    );
  }

  return (
    <Button
      variant="blue"
      onClick={onSend}
      disabled={!canSend}
      type="button"
      size="medium"
      className="chat-input__send-btn"
    >
      <IDHFormattedMessage id="ws_send" defaultMessage="Send" />
    </Button>
  );
}
